import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  byId: {},
  byType: {}
};

const setStateById = (draft, action) => {
  const {
    id,
    state
  } = action.payload;
  draft.byId[id] = {
    state
  };
};

const setStateByType = (draft, action) => {
  const {
    type,
    state
  } = action.payload;
  draft.byType[type] = {
    state
  };
};

const fetchFaqEntrySuccess = (draft, action) => {
  const {
    faqEntry,
    type
  } = action.payload;
  const faqEntryRecord = {
    entry: faqEntry,
    state: UiState.Success
  };
  if (type) draft.byType[type] = faqEntryRecord;
  draft.byId[faqEntry.id] = faqEntryRecord;
};

const faqEntrySlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setStateById,
    setStateByType,
    fetchFaqEntrySuccess
  }
});
export const {
  actions
} = faqEntrySlice;
export const plug = {
  [stateName]: faqEntrySlice.reducer
};
export default faqEntrySlice.reducer;